import { h, render, Component } from 'preact';
class TxrResourcesHubMobileFilter extends Component {
    state = {
        allTypes: true,
        caseStudies: false,
        insights: false,
        messageTemplates: false,
        eBooks: false,
        playbooks: false
    }
    componentDidMount() {
        this.setState({
            allTypes : this.props.context.allTypes,
            caseStudies: this.props.context.caseStudies,
            insights: this.props.context.insights,
            messageTemplates: this.props.context.messageTemplates,
            eBooks: this.props.context.eBooks,
            playbooks: this.props.context.playbooks
        });
    }
    setAll() {
        this.setState({
            allTypes : true,
            caseStudies: false,
            insights: false,
            messageTemplates: false,
            eBooks: false,
            playbooks: false,
        });
    }

    setType(type) {
        const state = { allTypes : false};
        state[type] = true;
        this.setState(state);
    }
    submit() {
        this.props.context.allTypes = this.state.allTypes;
        this.props.context.caseStudies = this.state.caseStudies;
        this.props.context.insights = this.state.insights;
        this.props.context.messageTemplates = this.state.messageTemplates;
        this.props.context.eBooks = this.state.eBooks;
        this.props.context.playbooks = this.state.playbooks;
        this.props.submit();
    }
    render() {
        return (
            <div class="txr-resources-hub-mobile-filter">
                <div class={'hub-filter__item' + (this.state.allTypes ? ' hub-filter__item-selected': '') } onClick={(e) => this.setAll()}>
                    All content Types
                </div>    
                <div class="hub-filter__line"></div>
                <div class={'hub-filter__item' + (this.state.caseStudies ? ' hub-filter__item-selected': '') } onClick={(e) => this.setType('caseStudies')}>
                    Case Studies
                </div>    
                <div class={'hub-filter__item' + (this.state.insights ? ' hub-filter__item-selected': '') } onClick={(e) => this.setType('insights')}>
                    Insights
                </div>    
                <div class={'hub-filter__item' + (this.state.messageTemplates ? ' hub-filter__item-selected': '') } onClick={(e) => this.setType('messageTemplates')}>
                    Message Templates
                </div>    
                <div class={'hub-filter__item' + (this.state.eBooks ? ' hub-filter__item-selected': '') } onClick={(e) => this.setType('eBooks')}>
                    eBooks & Reports
                </div>    
                <div class={'hub-filter__item' + (this.state.playbooks ? ' hub-filter__item-selected': '') } onClick={(e) => this.setType('playbooks')}>
                    Playbooks
                </div> 

                <button class="txr-button txr-action-button txr-black-text" type="button" onClick={(e) => this.submit()}>
                   <span class="txr-button__content">SAVE SELECTIONS AND CLOSE</span>
               </button>   
            </div>
        )
    }
}

export default TxrResourcesHubMobileFilter;